import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  :root{
    --primary-color:#FF383D;
    --secondary-color:#035755;
    --secondary-light-color:#0C6C44;
    --gray-color:#4B4F51;
  }

  * {
    padding: 0;
    margin: 0;
    border: 0;
    box-sizing: border-box
  }
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
  }
  body{
    font-family: 'Lato', sans-serif;
    overflow-x: hidden;
    background:#FFF;
  }
  html, body, #root{
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  main {
    display: block;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
    text-decoration: none;
    transition: all 250ms ease-out;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0; /* 3 */
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }
  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }
  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }

  ul{
    list-style: none;
  }

  .btn {
    border-radius: 46px;
    border: 2px solid var(--primary-color);
    padding: 0.8rem 1.8rem;
    color: var(--primary-color);
    box-shadow:0px 2px 5px rgba(0, 0, 0, .2);
    cursor: pointer;

    &:hover,
    &:focus,
    &.active {
      background: var(--primary-color);
      color: #fff !important;
    }
  }
`;
